export default "__VITE_ASSET__2d962ad7__"